import { ListItem, ListItemText } from "@material-ui/core";

import LongText from "./LongText";
import React from "react";

const TextItem = ({ label, value, maxWidth = 400, className }) => (
  <ListItem dense className={className}>
    <ListItemText
      primary={label}
      secondary={<LongText value={value} maxWidth={maxWidth} />}
    />
  </ListItem>
);

export default TextItem;
